import {UIArtefakt, UIArtefaktContainer} from './uiArtefakt';
import {Meldung} from './meldung';
import {UIParameter} from './uiParameter';

export class UiVorgang implements UIArtefaktContainer{
  UIArtefakt: UIArtefakt[];
  AngebotserstellungMoeglichJN: boolean;
  UIVorgangID: string;
  UIMeldung: Meldung[];
  UIParameter: UIParameter;
  Identifikator: string;
  UISeitensortierungSBPortal: UISeitensortierungSBPortal[];
}

export class UISeitensortierungSBPortal {
  MenuTitel: string;
  SeitenID: string;
  MenuSeitenAusgeblendetJN: boolean;
  UISeitensortierungSBPortal: UISeitensortierungSBPortal[];
}
